import { JSX } from 'react';
import { Container, RichText, Text, VerticalVideoGallery } from '@ahc-digital/component-library';
import { Placeholder, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { VERTICAL_VIDEO_CARD_CONTAINER } from 'src/shared/static';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { SwitchToPreviewMessage } from 'src/shared/SwitchToPreviewMessage';
import { GetVerticalVideoGallery } from './C42VerticalVideoGallery.service';
import { C42VerticalVideoGalleryProps } from './C42VerticalVideoGallery.types';

const Default = (props?: C42VerticalVideoGalleryProps): JSX.Element => {
  const { sitecoreContext } = useSitecoreContext();
  const { renderLink } = useConditionalRendering();
  const isEditing = sitecoreContext?.pageEditing ?? false;
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );
  const model = GetVerticalVideoGallery(props);

  if (isEditing && props?.rendering) {
    return (
      <SwitchToPreviewMessage componentName={props.rendering.componentName}>
        <Container>
          <div style={{ display: 'grid', gap: '0.5rem', marginBottom: '1rem' }}>
            <span>
              <b>Headline:</b>
            </span>
            <Text tag={model.headlineTag}>{model.headline}</Text>
          </div>
          <div style={{ display: 'grid', gap: '0.5rem', marginBottom: '1rem' }}>
            <span>
              <b>Support copy:</b>
            </span>
            <RichText>{model.supportCopy}</RichText>
          </div>
          <div style={{ display: 'grid', gap: '0.5rem', marginBottom: '1rem' }}>
            <span>
              <b>CTA:</b>
            </span>
            {renderLink(props.fields?.Cta, { required: true })}
          </div>
          <Placeholder name={VERTICAL_VIDEO_CARD_CONTAINER} rendering={props.rendering} />
        </Container>
      </SwitchToPreviewMessage>
    );
  }

  return (
    <VerticalVideoGallery
      {...model}
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
    />
  );
};

export default checkDatasourceForRendering<C42VerticalVideoGalleryProps>(Default);
